module.exports = __webpack_public_path__ + "img/干果2.e61c51b9.png";